<template>
  <div class="products-page-wrapper">

    <PageHeader
        :title="(blockData && blockData.page_title)"
        :subtitle="(blockData && blockData.custom_subheader) || ''"
    />

    <div class="products-page-inner" v-if="blockData && blockData.products">
      <div
          v-for="product in blockData.products"
          :key="product.id"
          class="product-row"
          :class="{ 'wide-card': product.description && product.description.trim() !== '' }"
      >
        <div class="product-card-header">
          <h2 class="product-name">{{ product.name }}</h2>
          <h4 v-if="product.subname" class="product-subname">{{ product.subname }}</h4>
        </div>

        <div class="product-card-body">
          <div class="product-info-col" v-if="product.description && product.description.trim() !== ''">
            <div class="product-description" v-html="product.description"></div>
          </div>

          <ProductGallery
              :images="product.images"
              :active-image="getActiveImage(product)"
              :product-name="product.name"
              :description="product.description"
              @change-image="(img) => setActiveImage(product.id, img)"
          />

        </div>

        <div class="product-card-footer">
          <a
              v-if="product.youtube_primary_link"
              :href="product.youtube_primary_link"
              target="_blank"
              rel="noopener noreferrer"
              class="btn-youtube"
          >
            <img src="/wp-content/themes/rufousone/img/youtube-bttn-small.jpg" alt="Watch Review" />
          </a>

          <a :href="product.amazon_url" target="_blank" rel="noopener noreferrer" class="buy-now-btn">
            <img src="/wp-content/themes/rufousone/img/amazon-bttn.png" alt="Buy on Amazon" />
          </a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { defineComponent } from 'vue';
import PageHeader from '../components/PageHeader.vue';
import ProductGallery from "../components/ProductGallery.vue";

export default defineComponent({
  name: 'ProductPage',
  components: {
    ProductGallery,
    PageHeader
  },
  props: {
    blockData: {
      type: Object,
      required: true,
      default: () => ({
        page_title: '',
        custom_header: '',
        custom_subheader: '',
        products: []
      })
    }
  },
  data() {
    return {
      activeGalleryMap: {}
    };
  },
  methods: {
    setActiveImage(productId, imageUrl) {
      this.activeGalleryMap = {
        ...this.activeGalleryMap,
        [productId]: imageUrl
      };
    },
    // Returns either the clicked image or falls back cleanly to the main array index image
    getActiveImage(product) {
      return this.activeGalleryMap[product.id] || product.images[0];
    }
  }
});
</script>